/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateWorkflowAccessDto { 
    workflowId: string;
    agency: string;
    allClients?: boolean;
    clients?: Array<string>;
}

